<div [ngClass]="{'row mt-2': firstSearch}" [style]="!firstSearch ? 'display: flex' : ''">
  <div [ngClass]="{'col-9' : !firstSearch || flightInfo, 'col-12': firstSearch && !flightInfo}">
    <div class="row">
      <div class="col-12">
        <h3 class="heading-5" *ngIf="firstSearch">
          {{ "common.searcher" | translate }}
        </h3>
        <h3 class="heading-5" *ngIf="!firstSearch">
          {{ "common.result" | translate }}
        </h3>
      </div>
    </div>
    <app-user-detail
      *ngIf="(isAdmin && canUseTRM) || isEmployee"
      [userUuid]="userToBook"
      (navigateEvent)="goBack()"
    ></app-user-detail>
    <div class="row">
      <!-- BUSCADOR -->
      <app-search-form
        style="width: 100%"
        [ngStyle]="{ cursor: !firstSearch ? 'pointer' : '' }"
        (click)="!firstSearch ? openSearchModal() : ''"
        (emitData)="newSearch($event)"
        (emitSelectedUsers)="handleSelectedUsers($event)"
        (emitSelectedTravelers)="handleSelectedTravelers($event)"
        (emitPackageRate)="handlePackageRate($event)"
        (emitProject)="handleSelectedProjects($event)"
        (emitSelectedPolicy)="handleSelectedPolicy($event)"
        [firstSearch]="firstSearch"
        [searchConfig]="searchConfig"
        [companyUuid]="companyUuid"
        [userToBook]="userToBook"
        [uuidUser]="uuidUser"
        [isAdmin]="isAdmin"
        [userFilters]="userFilters"
        [selectedPolicy]="selectedPolicy"
      ></app-search-form>
    </div>
    <div class="row mt-4">
      <div
        class="col-sm-12 empty-results"
        *ngIf="
          !firstSearch && (!hotelsList || hotelsList.length === 0) && !utilsService.loadingHotels
        "
      >
        <img src="assets/img/svg/empty-results.svg" alt="Empty results" />
        <p class="no-results">
          Ups... {{ "agency.search.search-homepage.no-results" | translate }}
        </p>
        <p>{{ "common.change-search" | translate }}</p>
      </div>
      <div *ngIf="utilsService.loadingHotels && firstSearch" class="skeleton">
        <div class="ph-item">
          <div class="ph-col-12">
            <div class="ph-row">
              <div class="ph-col-2 big"></div>
            </div>
          </div>
        </div>
        <div class="ph-item">
          <div class="ph-col-6">
            <div class="ph-gap ph-row-picture">
              <span class="ph-picture"></span>
              <div class="ph-col-8 empty">
                <div class="ph-row ph-gap-small ph-no-margin">
                  <div class="ph-col-4 ph-first"></div>
                  <div class="ph-col-2 empty"></div>
                  <div class="ph-col-6"></div>
                  <div class="ph-col-2 empty"></div>
                  <div class="ph-col-6"></div>
                  <div class="ph-col-4 empty"></div>
                  <div class="ph-col-2 big"></div>
                  <div class="ph-col-6 empty"></div>
                  <div class="ph-col-2 big"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="ph-col-6">
            <div class="ph-picture"></div>
          </div>
        </div>
      </div>
      <div
        class="col-sm-12"
        *ngIf="hotelsList && hotelsList.length > 0"
      >
        <div class="nav-container">
          <div class="nav">
            <ul ngbNav #nav="ngbNav" [(activeId)]="navActive" class="nav-tabs">
              <!-- TAB ALL -->
              <li [ngbNavItem]="1" (click)="showHotels = true">
                <a ngbNavLink>
                  <img
                    src="{{
                      navActive === 1
                        ? 'assets/img/svg/list-white.svg'
                        : 'assets/img/svg/list.svg'
                    }}"
                  />
                  {{ "common.list" | translate }}</a
                >
                <ng-template ngbNavContent>
                  <!-- HOTELES -->
                  <div class="row" id="listMap" *ngIf="!utilsService.loadingHotels">
                    <div
                      id="scrollableList"
                      class="col-md-7 col-sm-12"
                      *ngIf="showHotels"
                      style="min-width: 100%"
                    >
                      <div class="col-12 nopadding">
                        <div class="contentListHotels">
                          <app-search-card
                            *ngFor="
                              let hotel of hotelsList;
                              let last = last;
                              index as i
                            "
                            [mapHasBeenDragged]="mapHasBeenDragged"
                            [firstSearch]="firstSearch"
                            [hotelsMapCopy]="hotelMapsCopy"
                            [hotelsListCopy]="hotelListCopy"
                            [hotel]="hotel"
                            [canRequest]="canRequest"
                            [searchConfig]="searchConfig"
                            [originalSearchConfig]="originalSearchConfig"
                            [selectedUsers]="selectedUsers"
                            [selectedTravelers]="selectedTravelers"
                            [projectData]="projectData"
                            [selectedPolicy]="selectedPolicy"
                            [showHotels]="showHotels"
                            [filters]="filters"
                            [index]="i"
                            [userFilters]="userFilters"
                            [filtersApplicated]="filtersApplicated"
                            [totalNights]="totalNights(buildDate(searchConfig.checkIn), buildDate(searchConfig.checkOut))"
                            #item
                          >
                          </app-search-card>
                          <div
                            class="card horizontal"
                            id="endOfListCard"
                            *ngIf="isLastPage"
                          >
                            <div class="card-content">
                              <p>
                                {{
                                  "hotel.max-range-reached.title" | translate
                                }}
                              </p>
                              <button
                                class="custom-btn my-auto"
                                (click)="loadMoreHotelsPage()"
                              >
                                {{
                                  "hotel.max-range-reached.subtitle" | translate
                                }}
                              </button>
                            </div>
                          </div>
                        </div>
                        <div
                          *ngIf="utilsService.loadingHotels"
                          class="ph-item"
                          id="loading-shadow"
                        >
                          <div class="card horizontal">
                            <div id="cardContent" class="row mx-0 card-content">
                              <div id="hotelImage" class="card-img">
                                <div id="hotelImages" class="carousel slide" data-ride="carousel" wrap="true">
                                  <div class="carousel-inner">
                                    <div class="carousel-item active" >
                                      <img alt="no-image">
                                    </div>
                                  </div>
                                  <a class="carousel-control-prev" href="#hotelImages" role="button" data-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span class="sr-only">Previous</span>
                                  </a>
                                  <a class="carousel-control-next" href="#hotelImages" role="button" data-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span class="sr-only">Next</span>
                                  </a>
                                </div>
                                  <ng-template ngbSlide>
                                    <img alt="no-image" />
                                  </ng-template>
                                </div>
                              <div id="hotelData" class="col-12 card-stacked">
                                <div class="row">
                                  <h4 class="card-title"></h4>
                                  <div class="text-left divStarts pl-1"></div>
                                </div>
                                <div class="row">
                                  <div class="row">
                                    <div>
                                      <p class="card-text col-12"></p>
                                      <p class="card-text col-7"></p>
                                    </div>
                                    <div class="col-5 facilities-container">
                                      <div class="facilities"></div>
                                    </div>
                                  </div>
                                  <div class="row price">
                                    <div class="my-auto py-1 px-2">
                                      <h5 class="text-bold-600 my-auto"></h5>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-12">
                                      <span> </span>
                                      <span
                                        style="margin-top: 0; color: orange"
                                      >
                                        <span
                                          class="material-icons mr-0 px-0"
                                        ></span>
                                      </span>
                                      <!-- <span *ngIf="
                                          hotel.userBookingOption === 1
                                        " style="margin-top: 0; color: #52c9ad"><span class="material-icons mr-0 px-0"> checked </span>
                                            {{"search.card.allPreAuthorized" | translate }}</span> -->
                                    </div>
                                  </div>
                                </div>
                                <div class="row" id="colButtonGetHotel">
                                  <div class="dropdown">
                                    <a
                                      ><img
                                        src="assets/img/svg/black-map.svg" />
                                      <img
                                        src="assets/img/svg/ionic-ios-arrow-down.svg"
                                    /></a>
                                  </div>
                                  <div class="text-right"></div>
                                </div>
                                <div *ngIf="mapView" class="row map">
                                  <app-google-maps
                                    [listHotels]="hotelMaps"
                                    [firstSearch]="firstSearch"
                                    [mapHasBeenDragged]="mapHasBeenDragged"
                                    [searchConfig]="searchConfig"
                                    [fromCard] = "false"
                                    [selectedPolicy]="selectedPolicy"
                                    style="height: 100%; width: 100%"
                                  ></app-google-maps>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      *ngIf="length > paginationConf.pageSize"
                      class="d-flex justify-content-center mt-2 mb-2 col-12"
                    >
                      <mat-paginator
                        #paginator
                        [length]="length"
                        [pageSize]="paginationConf.pageSize"
                        (page)="onPageChange($event)"
                        showFirstLastButtons
                        [hidePageSize]="true"
                        style="border-radius: 15px"
                      >
                      </mat-paginator>
                    </div>
                  </div>
                </ng-template>
              </li>
              <li [ngbNavItem]="2" (click)="showHotels = false">
                <a ngbNavLink>
                  <img
                    src="{{
                      navActive === 2
                        ? 'assets/img/svg/map-white.svg'
                        : 'assets/img/svg/map.svg'
                    }}"
                  />
                  {{ "common.map" | translate }}</a
                >
                <ng-template ngbNavContent>
                  <app-google-maps
                    [listHotels]="hotelMaps"
                    [hotelsMapCopy]="hotelMapsCopy"
                    [hotelsListCopy]="hotelListCopy"
                    [singleSearch]="false"
                    [firstSearch]="firstSearch"
                    [mapHasBeenDragged]="mapHasBeenDragged"
                    [searchConfig]="searchConfig"
                    [canRequest]="canRequest"
                    [fromCard] = "false"
                    [selectedUsers]="selectedUsers"
                    [selectedTravelers]="selectedTravelers"
                    [selectedPolicy]="selectedPolicy"
                    [userFilters]="userFilters"
                    [filters]="filters"
                    [projectData]="projectData"
                    [originalSearchConfig]="originalSearchConfig"
                    (zoomOutEvent)="loadMoreHotelsPage()"
                    style="height: 100%; width: 100%"
                  ></app-google-maps>
                  <div
                    class="card horizontal"
                    id="endOfListCard"
                    *ngIf="isLastPage || navActive === 2"
                  >
                    <div class="card-content">
                      <p>
                        {{ "hotel.max-range-reached.title" | translate }}
                      </p>
                      <button
                        class="custom-btn my-auto"
                        (click)="loadMoreHotelsPage()"
                      >
                        {{ "hotel.max-range-reached.subtitle" | translate }}
                      </button>
                    </div>
                  </div>
                </ng-template>
              </li>
            </ul>
            <ul class="nav-tabs nav" *ngIf="showHotels">
              <li (click)="setFilter('distance'); filter()" class="nav-item">
                <a
                  class="nav-link"
                  [ngClass]="this.order.order === 'distance' ? 'sorted' : ''"
                >
                  {{ "common.distance" | translate }}
                </a>
              </li>
              <li (click)="setFilter('price'); filter()">
                <a
                  class="nav-link"
                  [ngClass]="this.order.order === 'price' ? 'sorted' : ''"
                >
                  {{ "agency.search.search-homepage.price" | translate }}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div [ngbNavOutlet]="nav" class="mt-2"></div>
      </div>
    </div>
  </div>
   <div
      class="filters-side-container"
      [ngClass]="{ 'filters-side-container--results': !firstSearch }"
    >
    
    <!-- FILTROS-->
    <div
      class="col-sm-12 card-filter"
      *ngIf="!firstSearch || utilsService.loadingHotels"
    >
      <mat-accordion style="margin-top: 1rem;">
      <mat-expansion-panel [expanded]="flightInfo ? false : true">
        <mat-expansion-panel-header>
          <mat-panel-title style="font-size: larger !important;">
            {{ "search.search-homepage.order-by" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="col-12">
          <div class="dropdown-stars">
            <div class="dropdown-toggle-stars" (click)="starsDropdownOpen = !starsDropdownOpen">
              {{ "search.filters.stars" | translate }}
              <i style="font-size: inherit;" class="fa fa-chevron-down ml-2" [ngClass]="{ 'rotate-icon': starsDropdownOpen }"></i>
            </div>
            <div class="dropdown-menu-stars" *ngIf="starsDropdownOpen">
            <ng-container *ngFor="let i of [0,1,2,3,4]; let index = index">
              <div class="px-sm-3 px-xs-5 custom-control custom-checkbox form-check mt-2">
                <input
                  class="custom-control-input form-check-input"
                  type="checkbox"
                  [id]="'star-' + (index + 1)"
                  [checked]="STARS_FILTERS[index]"
                  (change)="starsFilter(index)"
                />
                <label class="custom-control-label labelFilterSearch form-check-label" [for]="'star-' + (index + 1)">
                  {{ index + 1 }} 
                  {{ (index + 1) === 1 
                      ? ('search.filters.single-star' | translate) 
                      : ('search.filters.multiple-star' | translate) }}
                </label>
              </div>
            </ng-container>
          </div>
          </div>
        </div>
        <div class="col-12 mt-2" style="margin-top: 2rem !important;">
          <div class="dropdown-stars">
            <div class="dropdown-toggle-stars" (click)="lodgingDropdownOpen = !lodgingDropdownOpen">
              {{ "company.group.group-form.room-type" | translate }}
              <i style="font-size: inherit;" class="fa fa-chevron-down ml-2" [ngClass]="{ 'rotate-icon': lodgingDropdownOpen }"></i>
            </div>
            <div class="dropdown-menu-stars" *ngIf="lodgingDropdownOpen">
              <div *ngIf="isAdmin || !userFilters || userFilters.lodgingType === 'room' || userFilters.lodgingType === 'all'" class="px-sm-3 px-xs-5 custom-control custom-checkbox form-check mt-2">
                <input
                  class="custom-control-input form-check-input"
                  type="checkbox"
                  id="lodging-room"
                  [checked]="lodgingTypes.room"
                  (change)="toggleLodgingType('room')"
                />
                <label class="custom-control-label form-check-label" for="lodging-room">
                  {{ "common.hotel" | translate }}
                </label>
              </div>
              <div *ngIf="isAdmin || !userFilters || userFilters.lodgingType === 'apartment' || userFilters.lodgingType === 'all'" class="px-sm-3 px-xs-5 custom-control custom-checkbox form-check mt-2">
                <input
                  class="custom-control-input form-check-input"
                  type="checkbox"
                  id="lodging-apartment"
                  [checked]="lodgingTypes.apartment"
                  (change)="toggleLodgingType('apartment')"
                />
                <label class="custom-control-label form-check-label" for="lodging-apartment">
                  {{ "hotel.apartment" | translate }}
                </label>
              </div>
              <div *ngIf="isAdmin || !userFilters || userFilters.lodgingType === 'all'" class="px-sm-3 px-xs-5 custom-control custom-checkbox form-check mt-2">
                <input
                  class="custom-control-input form-check-input"
                  type="checkbox"
                  id="lodging-all"
                  [checked]="lodgingTypes.all"
                  (change)="toggleLodgingType('all')"
                />
                <label class="custom-control-label form-check-label" for="lodging-all">
                  {{ "common.all" | translate }}
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 mt-2" style="margin-top: 2rem !important;">
          <div class="dropdown-stars">
            <div class="dropdown-toggle-stars" (click)="cancellationDropdownOpen = !cancellationDropdownOpen">
              {{ "search.filters.cancellation-fees" | translate }}
              <i
                style="font-size: inherit;"
                class="fa fa-chevron-down ml-2"
                [ngClass]="{ 'rotate-icon': cancellationDropdownOpen }"
              ></i>
            </div>

            <div class="dropdown-menu-stars" *ngIf="cancellationDropdownOpen">
              <div class="px-sm-3 px-xs-5 custom-control custom-checkbox form-check mt-2">
                <input
                  class="custom-control-input form-check-input"
                  type="checkbox"
                  id="cancel-no-fees"
                  [checked]="cancellationTypes.noFeesUntil"
                  (change)="toggleCancellationType('noFeesUntil')"
                />
                <label class="custom-control-label form-check-label" for="cancel-no-fees">
                  {{ "search.filters.free-cancellation" | translate }}
                </label>
              </div>

              <div class="px-sm-3 px-xs-5 custom-control custom-checkbox form-check mt-2">
                <input
                  class="custom-control-input form-check-input"
                  type="checkbox"
                  id="cancel-partial-fees"
                  [checked]="cancellationTypes.partialFees"
                  (change)="toggleCancellationType('partialFees')"
                />
                <label class="custom-control-label form-check-label" for="cancel-partial-fees">
                  {{ "search.filters.partial-fees" | translate }}
                </label>
              </div>

              <div class="px-sm-3 px-xs-5 custom-control custom-checkbox form-check mt-2">
                <input
                  class="custom-control-input form-check-input"
                  type="checkbox"
                  id="cancel-non-refundable"
                  [checked]="cancellationTypes.nonRefundable"
                  (change)="toggleCancellationType('nonRefundable')"
                />
                <label class="custom-control-label form-check-label" for="cancel-non-refundable">
                  {{ "search.search-booked.no-cancel" | translate }}
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 mt-2" style="margin-top: 2rem !important;">
          <h6 class="mt-2 ml-2 col-12">
            {{ "hotel.corporative-rates" | translate }}
          </h6>

          <div class="form-group ml-2 my-auto col-12">
            <div class="row">
              <div class="col-12">
                <div class="px-sm-3 px-xs-5 custom-control custom-checkbox">
                  <input
                    class="custom-control-input form-check-input"
                    type="checkbox"
                    id="vyootripOnly"
                    [checked]="vyootripOnly"
                    (change)="toggleVyootripOnly($event)"
                  />
                  <label class="custom-control-label form-check-label" for="vyootripOnly">
                    {{ "hotel.corporative-rate-only" | translate }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <h6 class="mt-2 ml-2 col-12">
            {{ "search.filters.title" | translate }}
          </h6>
          <div class="form-group ml-2 my-auto col-12" id="rowFilters">
            <div class="row">
              <div class="col-12" *ngFor="let filter of filters">
                <div class="px-sm-3 px-xs-5 custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    name="filtersHotel"
                    [checked]="isChecked(filter.code)"
                    [id]="filter.code"
                    (change)="applyFilters($event)"
                  />
                  <label
                    class="custom-control-label labelFilterSearch"
                    [for]="filter.code"
                    >{{ filter.name }}</label
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <h6 class="mt-2 ml-2 col-12">
            {{ "agency.search.filters.price" | translate }}
          </h6>
          <div class="col-12">
            <div class="custom-slider">

              <div class="price-filter-container">
                <div class="price-inputs-row">
                  <div class="price-input-box">
                    <label>Min.</label>
                    <input
                      type="number"
                      class="price-input"
                      [ngModel]="minPriceInputValue"
                      [min]="options?.floor"
                      [max]="highValue || options?.ceil"
                      step="0.01"
                      (ngModelChange)="onMinPriceInputChange($event)"
                      (blur)="commitMinPriceInput()"
                      (keydown.enter)="commitMinPriceInput()"
                    />
                  </div>

                  <div class="price-input-box">
                    <label>Máx.</label>
                    <input
                      type="number"
                      class="price-input"
                      [ngModel]="maxPriceInputValue"
                      [min]="value || options?.floor"
                      [max]="options?.ceil"
                      step="0.01"
                      (ngModelChange)="onMaxPriceInputChange($event)"
                      (blur)="commitMaxPriceInput()"
                      (keydown.enter)="commitMaxPriceInput()"
                    />
                  </div>
                </div>

                <ngx-slider
                  [(value)]="value"
                  [(highValue)]="highValue"
                  [options]="options"
                  (userChangeEnd)="priceFilter($event)"
                ></ngx-slider>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 d-flex justify-content-center">
          <button
            id="filterSearchBtn"
            class="custom-btn my-auto"
            (click)="applyFiltersAction()"
          >
            {{ "common.search" | translate }}
          </button>
        </div>
        <!-- FIN FILTROS -->
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <div id="price-col" *ngIf="flightInfo" >
    <mat-accordion style="margin-top: 1rem;">
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ "flight.flight-info" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
    <div id="details-container">
      <span *ngIf="flightInfo.canUseResident" class="resident-applied">{{ 'flight.resident-applied' | translate }}</span>
      <div class="details-buy-text" [ngClass]="{ 'no-fare': flightInfo.fareSelected == null }">
        <ng-container *ngIf="flightInfo.fareSelected && flightInfo.farePricing">
          <div class="buy-text">
            <div>
              <div *ngIf="flightInfo.isAuthorization"
                style="display: flex; justify-content: center;">
                <span class="admin-permission-msg">{{ "authorization.permissions-required" | translate }}</span>
              </div>
            </div>
            <div *ngIf="flightInfo.fareSelected">
              <p style="margin: 0;">{{flightInfo.flightRequest.from}} - {{flightInfo.flightRequest.to}}</p>
              <p>{{flightInfo.selectedFlights[0][0].object.departure_date | date}} - {{flightInfo.selectedFlights[flightInfo.selectedFlights.length -1][0].object.departure_date | date}}</p>              
              <div class="total-price base-price">
                <p>{{ "hotel.base-rate" | translate }}:</p>
                <p>
                  {{ ((company && !company?.showCommissions) || isEmployee)
                  ? flightInfo.farePricing.total
                  : flightInfo.farePricing.amount| price}} €
                </p>
              </div>
              <div class="total-price fee-emit" *ngIf="company?.showCommissions || isEmployee">
                <p>{{ "flight.result-flight.fee-emit" | translate }}:</p>
                <p>{{ (flightInfo.farePricing.total - flightInfo.farePricing.amount) | price }} €</p>
              </div>
              <div class="total-price baggage-price" *ngIf="flightInfo.selectBaggage?.length > 0">
                <p>{{ "my-bookeds.flight.baggage" | translate }} ({{ flightInfo.baggagesNumber }}):</p>
                <p>{{ flightInfo.totalBaggagePrice | price }} €</p>
              </div>
              <div class="total-price baggage-price" *ngIf="flightInfo.selectedPriority?.length > 0">
                <p>{{ "flight.detail-flight.priority" | translate }}:</p>
                <p class="price-nowrap">
                  {{ flightInfo.priorityPrice | price }}<span class="currency">&nbsp;€</span>
                </p>
              </div>
              <div class="total-price baggage-price" *ngIf="flightInfo.selectedSeats">
                <p>{{ "my-bookeds.train-flight.seat" | translate }}: </p>
                <p>{{ flightInfo.expectedAmountSeats | price }} €</p>
              </div>
              <div class="total-price total-price-label">
                <p>{{ "flight.result-flight.total-price" | translate }}:</p>
                <p>{{ flightInfo.totalPrice | price }} €</p>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </mat-expansion-panel>
  </mat-accordion>
  </div>
  </div>

</div>
